import { useNavigate } from "react-router";
import { useT } from "@/utils/intlUtils";
import addIcon from "@/assets/transfer/create.png";

export default () => {
  const navigate = useNavigate();
  const t = useT();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
      onClick={() => {
        navigate("/address/create");
      }}
    >
      <img src={addIcon} style={{ width: 25, height: 25, marginRight: 6 }} />
      {t("新增")}
    </div>
  );
};
